export const useLocationStore = defineStore('locationStore', () => {
  const accountSettingsStore = useAccountSettingsStore();
  const locationsForFitterStore = useGetLocationByFitterIdStore();
  const settingsStore = useSettingsStore();

  const location = ref<LocationDTO | null>(null);
  const settingsKey = 'defaultMaterialLocation';

  function getLocation(): void {
    location.value = null;
    const storageLocation = settingsStore.settings.defaultMaterialLocation;
    const locations = locationsForFitterStore._getLocationByFitterId;
    const locationConnectedToFitter = locations.find(loc => loc.ID === storageLocation?.ID);

    if (locationConnectedToFitter) {
      location.value = locationConnectedToFitter;
    } else {
      const mainLocationID = accountSettingsStore.accountSettings.MainLocationID;
      const matchingLocation = locations.find(loc => loc.ID === mainLocationID);

      if (matchingLocation) {
        location.value = matchingLocation;
      }
    }
  }

  async function saveLocation(newLocation: LocationDTO | null): Promise<void> {
    await settingsStore.set(settingsKey, newLocation);
    location.value = newLocation;
  }

  return {
    _location: location,
    location: readonly(location),
    saveLocation,
    getLocation

  };
});
